import { Button, Col, Row, Typography } from "antd";
import React from "react";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";
import { MessageInstance } from "antd/lib/message/interface";

type KeyFieldProps = {
  message: MessageInstance
  value?: string | undefined;
  placeholder?: string | undefined;
};

const KeyField = ({ message, value, placeholder }: KeyFieldProps) => {
  const [showCopySuccess, setShowCopySuccess] = React.useState(false);

  const onCopy = () => {
    if (showCopySuccess) return;
    if (!navigator.clipboard) {
      message.error("Clipboard API not supported");
      return;
    } else if (!value) {
      message.error("License key not found");
      return;
    }
    navigator.clipboard.writeText(value);
    message.success("License key copied to clipboard");
    setShowCopySuccess(true);
    setTimeout(() => {
      setShowCopySuccess(false);
    }, 1000);
  };

  return (
    <Typography>
      <pre className="key_field">
        <Row align="middle">
          <Col flex="auto" className="key_field__inner">
            <code className="key_field__code"
            >
              {value || placeholder || ""}
            </code>
          </Col>
          <Col>
            <Button
              type="link"
              className="key_field__button"
              onClick={onCopy}
            >
              {showCopySuccess ? <CheckOutlined rev={undefined} /> : <CopyOutlined rev={undefined} />}
            </Button>
          </Col>
        </Row>
      </pre>
    </Typography>
  );
};

export default KeyField;
